import { render, staticRenderFns } from "./UpdateTerm.vue?vue&type=template&id=24969c9e&scoped=true"
import script from "./UpdateTerm.vue?vue&type=script&lang=js"
export * from "./UpdateTerm.vue?vue&type=script&lang=js"
import style0 from "./UpdateTerm.vue?vue&type=style&index=0&id=24969c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24969c9e",
  null
  
)

export default component.exports